import MayorLeonard from '#/utils/dialogues/MayorLeonard.js'
import DwarfBili from '#/utils/dialogues/DwarfBili.js'
import Bartender from '#/utils/dialogues/Bartender.js'
import NaniAndBiliRescue from '#/utils/dialogues/NaniAndBiliRescue.js'

export default {
  MAYOR_LEONARD: MayorLeonard,
  DWARF_BILI: DwarfBili,
  BARTENDER: Bartender,
  NANI_AND_BILI_RESCUE: NaniAndBiliRescue
}



// WEBPACK FOOTER //
// ./src/assets/js/game/utils/Dialogues.js